import Flag from "@/components/svg/Flag";
import { isFilled } from "@prismicio/client";
import { PrismicRichText } from "@prismicio/react";

/**
 * Highlighted card with the flag illustration and a closing sentence.
 * @param {{ text: import("@prismicio/client").RichTextField }} props
 */
const Card = ({ text }) => {
  if (!isFilled.richText(text)) return null;

  return (
    <div className="flex w-full flex-col items-center gap-10 rounded-[10px] bg-beige-50 p-[30px] lg:flex-row">
      <Flag className="h-[100px] w-auto lg:h-[84px]" />
      <div className="w-full min-w-0 flex-1">
        <PrismicRichText
          field={text}
          components={{
            paragraph: ({ children }) => (
              <p className="p-lg-n text-bleu not-last:mb-5">{children}</p>
            ),
            strong: ({ children }) => <strong className="md">{children}</strong>,
            em: ({ children }) => <em>{children}</em>,
            hyperlink: ({ children, node }) => (
              <a href={node.data.url} className="underline underline-offset-2">
                {children}
              </a>
            ),
          }}
        />
      </div>
    </div>
  );
};

export default Card;
